/*eslint-disable */
import React, { FC, useState, useRef, useContext } from "react";
import { createUseStyles, useTheme } from "react-jss";

import styles from "./styles";
import Info from "Assets/images/info_blue.svg";
import ArrowBack from "Assets/images/arrow_back.svg";
import { sanitize } from "dompurify";

import Close from "Assets/images/modal_close.svg";
import { motion } from "framer-motion";
import {
  getAwsVideoUrl,
  getVimeoVideoUrl,
  getYoutubeVideoUrl,
} from "Components/Videoviewer/Videoviewer";
import { MapContext } from "Context/MapContext";
import ShareMenuContainer from "Containers/ShareMenu";
import Navigate from "Assets/images/navigation_caret.svg";
import clsx from "clsx";

interface Props {
  media: any[];
  selectedIdx: number;
  changeDisplay: (val: any) => void;
  handleMediaClick: any;
}

const VideoViewerSmallViewPort: FC<Props> = (props: Props) => {
  const { media, selectedIdx, changeDisplay } = props;
  const useStyles = createUseStyles(styles);

  const videoRef = useRef(null);
  const { instId, locId } = useContext(MapContext);

  const [description, setDescription] = useState(false);
  const [open, setIsOpen] = useState(true);
  const shareUrl = `${process.env.REACT_APP_API_BASE_URL}tour/videos/${instId}/${locId}?id=${media[selectedIdx]?.id}`;

  const theme = useTheme();

  const classes = useStyles({ theme, ...props, state: { description } });

  const { type, videoid } = media[selectedIdx];

  const animations = {
    open: {
      x: "0%",
      transition: {
        ease: [0.28, 0.57, 0.2, 1],
        duration: 0.5,
      },
    },
    closed: {
      x: "-100%",
      transition: {
        ease: "easeIn",
        duration: 0.25,
        onComplete: () => {
          changeDisplay(false);
        },
      },
    },
  };

  const getVideo = (type: string) => {
    let url: string;
    switch (type) {
      case "aws":
        url = getAwsVideoUrl(media[selectedIdx]);
        return <video className={classes.awsVideo} controls src={url}></video>;
      case "vimeo":
        url = getVimeoVideoUrl(media[selectedIdx]);
        return <iframe src={url} title="Video Player" frameBorder="0" />;
      case "campusreel":
      case "youtube":
        url = type === "campusreel" ? media[selectedIdx].url || media[selectedIdx].videoid
        : getYoutubeVideoUrl(media[selectedIdx]);
        return (
          <iframe
            id="video"
            frameBorder="0"
            allowFullScreen
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            title="YouTube video player"
            src={url}
            data-testid="video"
            style={{height: type === "campusreel" ? "calc(100vw * .65)" : "100%"}}
          ></iframe>
        );
      default:
        return <div>Video Type Not Found</div>;
    }
  };

  return (
    <>
      <motion.div
        initial={"closed"}
        variants={animations}
        animate={open ? "open" : "closed"}
        className={classes.viewer}
      >
        <div className={classes.topContainer}>
          <ArrowBack
            onClick={(e: any) => {
              e.stopPropagation();
              videoRef.current.remove();
              setIsOpen(false);
            }}
          />
          {media[selectedIdx].description && (
            <Info
              onClick={(e: any) => {
                e.stopPropagation();
                setDescription(true);
              }}
              data-testid="info"
            />
          )}
        </div>
        <div
          className={classes.videoContainer}
          ref={videoRef}
          data-testid="container"
        >
          {getVideo(type)}
        </div>
        <div className={classes.videoTitle} data-testid="title">
          {media[selectedIdx].title}
        </div>
        <div className={classes.navigate}>
          <div
            className={classes.caret}
            onClick={(e) => {
              e.stopPropagation();
              props.handleMediaClick(selectedIdx - 1);
            }}
          >
            {selectedIdx > 0 && <Navigate />}
          </div>

          <div className={classes.counter}>
            {selectedIdx + 1}/{media.length}
          </div>

          <div
            className={clsx(classes.caret, classes.rotate)}
            onClick={(e) => {
              e.stopPropagation();
              props.handleMediaClick(selectedIdx + 1);
            }}
          >
            {selectedIdx !== media.length - 1 && <Navigate />}
          </div>
        </div>
        {description && (
          <div className={classes.description} data-testid="description">
            <div
              className={classes.closeIcon}
              onClick={(e: any) => {
                e.stopPropagation();
                setDescription(false);
              }}
            >
              <Close />
            </div>
            <div 
              className={classes.descriptionText} 
              dangerouslySetInnerHTML={{
                __html: sanitize(media[selectedIdx].description || media[selectedIdx].title, {
                  ADD_ATTR: ["target"],
                }),
              }}
            >
            </div>
          </div>
        )}
        <div>
          <span
            style={{
              cursor: "pointer",
              position: "fixed",
              bottom: "0%",
              right: "5%",
            }}
          >
            <ShareMenuContainer url={shareUrl} svgColor="#FFFFFF" />
          </span>
        </div>
      </motion.div>
    </>
  );
};

export default VideoViewerSmallViewPort;
